import React from 'react';

const ElementToolbar = ({ onAddElement }) => {
    const elements = [
        { type: 'text', icon: 'T', label: 'Text' },
        { type: 'address', icon: '📧', label: 'Adresse' },
        { type: 'logo', icon: '🖼️', label: 'Logo' },
        { type: 'image', icon: '🖼️', label: 'Bild' },
        { type: 'rectangle', icon: '▭', label: 'Rechteck' },
        { type: 'line', icon: '━', label: 'Linie' }
    ];

    return (
        <div className="element-toolbar">
            <h6 className="mb-3">Elemente</h6>
            {elements.map(el => (
                <button
                    key={el.type}
                    className="element-button"
                    onClick={() => onAddElement(el.type)}
                    title={`${el.label} hinzufügen`}
                >
                    <span style={{ fontSize: '20px' }}>{el.icon}</span>
                    <span>{el.label}</span>
                </button>
            ))}
            <hr />
            <div className="mt-3">
                <small className="text-muted">
                    <strong>Tipp:</strong> Klicke auf ein Element auf dem Canvas, um es auszuwählen und zu bearbeiten.
                </small>
            </div>
        </div>
    );
};

export default ElementToolbar;
